import DiscoveryModule from "./components/DiscoveryModule";
import BrandAuditModule from "./components/BrandAuditModule"; // V1: Brand/Product only
import BrandAuditV2Module from "./components/BrandAuditV2Module"; // V2: Brand/Product + Category
import CategoryAnalysisModule from "./components/CategoryAnalysisModule";
import MonitoringModule from "./components/MonitoringModule";

/**
 * §6 extensibility point — now also the tab registry HomePageNew.js's tab
 * bar is built from (see TAB_ORDER there). A module key with no entry here
 * simply has no renderer; its tab (if listed in TAB_ORDER) shows as
 * disabled/"coming soon" rather than being removed, so the full intended
 * tab sequence stays visible while modules land one at a time.
 */
const MODULE_RENDERERS = {
  discovery: DiscoveryModule,
  brandAudit: BrandAuditModule,
  categoryAnalysis: CategoryAnalysisModule,
  monitoring: MonitoringModule,
};

// Users with the is_assessment_ui_enabled flag get the merged Assessment tab (Brand/Product + Category runs in
// one list, via BrandAuditV2Module) and no separate Category Analysis tab; everyone else keeps the
// original modules above. See isAssessmentUiOn in utils/navFlags.js.
const ASSESSMENT_UI_MODULE_RENDERERS = {
  discovery: DiscoveryModule,
  brandAudit: BrandAuditV2Module,
  monitoring: MonitoringModule,
};

export const getModuleRenderers = (assessmentUi) =>
  assessmentUi ? ASSESSMENT_UI_MODULE_RENDERERS : MODULE_RENDERERS;

export default MODULE_RENDERERS;
